/* eslint-disable */
import '../../../assets/css/main.scss';
import { Component, Renderer2 } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  ActivatedRoute,
} from '@angular/router';
import { LocalStorageService } from '../../shared/services/localstorage.service';
import { LoggerService } from '../../shared/services/logger.service';
import { ApplicationProxyService } from '../../shared/services/applicationproxy.service';
import { DTMService } from '../../shared/services/dtm.service';
import { StartUpService } from '../../shared/services/startup.service';
import { NgRedux, DevToolsExtension } from '@angular-redux/store';
import reducer from '../../reducers/index';
import { ApplicationActions } from '../../actions/application.actions';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { TimeOutService } from '../../shared/services/timeout.service';
import { RouteParamsHandler } from '../../shared/services/routeParamsHandler.service';
import { CookieService } from 'angular2-cookie/core';
import {
  AppSteps,
  QuestionnaireSteps,
} from '../../shared/models/Enum/ProgressBarSteps';

@Component({
  selector: 'root',
  template: require('./root.component.html'),
})
export class RootComponent {
  routeIsQuestionniare = false;
  routeIsRecommendation = false;
  showPageErrors = true;
  showBottomPageErrors = false;
  showSideBar = true;
  routeHasSideBarExcluded = false;

  constructor(
    appProxy: ApplicationProxyService,
    dtm: DTMService,
    router: Router,
    ls: LocalStorageService,
    logService: LoggerService,
    startUp: StartUpService,
    redux: NgRedux,
    devTools: DevToolsExtension,
    route: ActivatedRoute,
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    timeoutService: TimeOutService,
    routeParamsHandler: RouteParamsHandler,
    cookies: CookieService,
    renderer2: Renderer2
  ) {
    this.appProxy = appProxy;
    this.dtm = dtm;
    this.redux = redux;
    this.router = router;
    this.route = route;
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.timeoutService = timeoutService;
    this.logService = logService;
    this.cookies = cookies;
    this.routeParamsHandler = routeParamsHandler;
    this.renderer2 = renderer2;

    this.pageErrorSubscription = this.flowManager.pageErrorObj.subscribe(
      (event) => {
        this.pageError = event;
      }
    );

    // WARNING THIS IS A POC MAYBE THIS SHOULD NOT BE HERE !!!!!!
    // We don't want to block the app while waiting to down load the store
    // We can just check to see if window.sitetags is there
    // If not then all well we just don't fire to the datalayer
    this.appProxy.getSiteTags((res) => (window.sitetags = res));
    // The POC Stops here

    // We can gate this for dev only later
    let enhancers = [];
    if (window.__REDUX_DEVTOOLS_EXTENSION__)
      enhancers = [...enhancers, devTools.enhancer()];

    redux.configureStore(reducer, {}, [], enhancers);

    // Set Step states
    this.appActions.setData('progressBar.expanded', false);

    // What app are we ?1?!
    startUp.init();
    this.isMobile = this.appActions.getData('isMobile', false);

    this.isRobo = this.flowManager.getAppType() === 'tka';

    // Listen for the route Events Life Cycle
    router.events.subscribe((event) => {
      // We are in a life cycle and we just this hook
      // This changes the layout based on the home page or not
      // And always scroll to the top of the page when the route changes

      if (event instanceof NavigationStart) {
        // Close the progress bar
        this.appActions.setData('progressBar.expanded', false);
        this.faqReset = false;
      }

      if (event instanceof NavigationEnd) {
        this.faqReset = true;
        // Needed for test bad routes
        this.endURL = event.url.substr(1);
        // test for home
        const testHome = /^(\/)(\/?\?{0}|\/?\?{1}.*)$/.test(event.url);
        // test for MP Questionnaire routes
        const questionnaireRegexList = [
          /^\/cash-allocation/,
          /^\/goal/,
          /^\/time-horizon/,
          /^\/financial-picture/,
          /^\/risk-tolerance/,
          /^\/strategy-type/,
          /^\/retirement/,
          /^\/recommendation/,
          /^\/explore-other-options/,
        ];
        // test for MP Questionnaire routes
        const documentUploadRegexList = [
          /^\/document-uploader/,
          /^\/welcome-back/,
          /^\/document-confirmation-received/,
          /^\/document-check-your-inbox/,
        ];

        const sideBarExlcusionList = [
          /^\/document-confirmation-received/,
          /^\/document-check-your-inbox/,
          /^\/error-submitting-app/,
          /^\/welcome-back/,
          /^\/rejected-app/,
          /^\/pending-app/,
        ];

        // Where are we??
        this.routeIsHome =
          testHome ||
          event.url === '/(aux:modal)' ||
          /^\/get-started/.test(event.url);
        this.routeIsWelcomeInvestor = /^\/welcome-investor/.test(event.url);
        this.routeIsQuestionniare = questionnaireRegexList.some((rx) =>
          rx.test(event.url)
        );
        this.routeIsRecommendation =
          /^\/recommendation/.test(event.url) ||
          /^\/explore-other-options/.test(event.url);
        this.routeIsDocumentUpload = documentUploadRegexList.some((rx) =>
          rx.test(event.url)
        );
        this.showSideBar = !sideBarExlcusionList.some((rx) =>
          rx.test(event.url)
        );

        this.showTopPageErrors =
          !this.routeIsQuestionniare && !this.routeIsDocumentUpload;
        this.showBottomPageErrors = this.routeIsDocumentUpload;

        if (event.url === '/select-account-type') {
          this.routeIsSelect = true;
          this.isAuth = this.flowManager.isAuthed;
        } else {
          this.routeIsSelect = false;
        }

        // Progress Bar
        this.showProgress =
          !this.routeIsHome &&
          !this.routeIsTimedOut &&
          !this.routeIsWelcomeInvestor &&
          !this.routeIsDocumentUpload;
        this.showProgressHome = this.routeIsHome || this.routeIsWelcomeInvestor;
        if (this.showProgress) {
          this.stepsRoute = this.routeIsQuestionniare ? 'questionnaire' : 'app';
        } else if (this.showProgressHome) {
          this.stepsRoute = 'home';
        }

        if (event.url === '/timed-out') {
          this.routeIsTimedOut = true;
          this.flowManager.resetPageError();
        } else {
          this.routeIsTimedOut = false;
        }

        if (!event.urlAfterRedirects.includes('(aux:modal)')) {
          const sanitizedPath = event.urlAfterRedirects
            .split('?')[0]
            .replace('/', '');
          this.dtm.injectPageData(sanitizedPath);
        }
        this.renderer2.setStyle(
          document.getElementById('handshake-loader'),
          'display',
          'none'
        );
      }
    });
  }

  ngOnInit() {
    document.onmousedown = () => this.timeoutService.extendTimeout();
    document.ontouchstart = () => this.timeoutService.extendTimeout();
    document.onclick = () => this.timeoutService.extendTimeout();
    document.onmouseup = (event) => this._siteTagCheck(event.target.id);
    document.onscroll = () => this.timeoutService.extendTimeout();
    document.onkeypress = () => this.timeoutService.extendTimeout();

    this.routeParamsHandler.checkRouteParams(location);
    if (this.cookies.getAll().ADTRK) {
      const adtrkCookie = decodeURIComponent(this.cookies.getAll().ADTRK);
      this.appActions.setData('ApplicationInformation.ADTRK', adtrkCookie);
    }
  }

  // WARNING THIS IS A POC MAYBE THIS SHOULD NOT BE HERE !!!!!!
  // We don't want to block the app while waiting to down load the store
  // We can just check to see if window.sitetags is there
  // If not then all well we just don't fire to the datalayer
  _siteTagCheck(id) {
    if (window.sitetags !== undefined && id !== undefined) {
      if (window.sitetags[id] !== undefined) {
        this.dtm.userAction(id);
      }
    }
  }

  ngOnDestroy() {
    this.pageErrorSubscription.unsubscribe();
  }
}
